<template>
  <transition name="modal-fade">
    <div
      v-if="isVisible"
      class="modal-overlay"
      @click.self="close"
    >
      <div
        class="modal-container"
        :style="{ width: maxWidth }"
      >
        <div class="modal-header">
          <slot name="header">
            <h3>{{ title }}</h3>
          </slot>
          <button
            class="modal-close-button"
            @click="close"
          >
            &times;
          </button>
        </div>
        <div class="modal-body">
          <slot />
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button
              class="modal-cancel-button"
              @click="close"
            >
              Cancel
            </button>
            <button
              class="modal-confirm-button"
              @click="confirm"
            >
              Confirm
            </button>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    title: {
      type: String,
      default: 'Confirmation'
    },
    maxWidth: {
      type: String,
      default: '500px'
    }
  },
  data() {
    return {
      isVisible: false
    };
  },
  methods: {
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
      this.$emit('cancel');
    },
    confirm() {
      this.isVisible = false;
      this.$emit('confirm');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  max-height: 90%;
  position: relative;
  overflow: hidden; /* For rounded corners */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
  margin-bottom: 20px;
}

.modal-header h3 {
  font-size: 1.6rem;
  color: #333;
  margin: 0;
}

.modal-close-button {
  background: none;
  border: none;
  font-size: 2.2rem;
  cursor: pointer;
  color: #888;
  transition: color 0.2s ease;
}

.modal-close-button:hover {
  color: #555;
}

.modal-body {
  flex-grow: 1;
  overflow-y: auto;
  font-size: 1.1rem;
  line-height: 1.6;
  color: #555;
}

.modal-footer {
  border-top: 1px solid #eee;
  padding-top: 15px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.modal-cancel-button, .modal-confirm-button {
  padding: 12px 25px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.05rem;
  font-weight: 600;
  transition: all 0.2s ease;
}

.modal-cancel-button {
  background-color: #e0e0e0;
  color: #555;
}

.modal-cancel-button:hover {
  background-color: #d0d0d0;
}

.modal-confirm-button {
  background-color: #ef4444; /* Changed to danger red */
  color: white;
}

.modal-confirm-button:hover {
  background-color: #dc2626; /* Darker red on hover */
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(239, 68, 68, 0.2); /* Adjusted shadow for red */
}

/* Transitions */
.modal-fade-enter-active, .modal-fade-leave-active {
  transition: all 0.3s ease;
}

.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.modal-fade-enter .modal-container,
.modal-fade-leave-to .modal-container {
  transform: scale(0.9) translateY(-20px);
}
</style>
